import {
  Box,
  Container,
  Heading,
  Link,
  SimpleGrid,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

const SEAT = 'Αρτάκης 64, 17124 Νέα Σμύρνη, Αττική';
const GEMI_URL = 'https://publicity.businessportal.gr/company/160351403000';

const rows: { el: string; en: string; value: ReactNode }[] = [
  {
    el: 'Επωνυμία',
    en: 'Company name',
    value: 'SILENTECH ΜΟΝΟΠΡΟΣΩΠΗ Ι.Κ.Ε. (SILENTECH SINGLE MEMBER P.C.)',
  },
  { el: 'Διακριτικός τίτλος', en: 'Trade name', value: 'SILENTECH ΙΚΕ' },
  {
    el: 'Αριθμός Γ.Ε.ΜΗ.',
    en: 'GEMI number',
    value: (
      <Link href={GEMI_URL} isExternal textDecoration="underline">
        160351403000
      </Link>
    ),
  },
  { el: 'Α.Φ.Μ.', en: 'VAT number', value: '801624783' },
  { el: 'Έδρα', en: 'Registered seat', value: SEAT },
  {
    el: 'Email',
    en: 'Email',
    value: <Link href="mailto:info@silentech.gr">info@silentech.gr</Link>,
  },
  {
    el: 'Τηλέφωνο',
    en: 'Phone',
    value: <Link href="tel:+302130105684">+30 213 010 5684</Link>,
  },
  {
    el: 'Εταιρικό κεφάλαιο',
    en: 'Share capital',
    value: '3.000 € (1.000 κεφαλαιακά μερίδια ονομαστικής αξίας 3 € έκαστο)',
  },
  {
    el: 'Διαχειριστής',
    en: 'Managing director',
    value: 'Παναγιώτης Γεωργακόπουλος, διαχειριστής από 02/08/2021',
  },
  {
    el: 'Εταίροι',
    en: 'Partners',
    value: 'Παναγιώτης Γεωργακόπουλος, μοναδικός εταίρος (100%)',
  },
];

export const CompanyInfo = () => {
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const mutedText = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box as="section" id="company" borderTop="1px" borderColor={borderColor} py={10}>
      <Container maxW="container.lg">
        <Heading as="h2" size="md" mb={1}>
          Εταιρικά στοιχεία
        </Heading>
        <Text fontSize="sm" color={mutedText} mb={6}>
          Company information
        </Text>
        <SimpleGrid
          as="dl"
          columns={{ base: 1, md: 2 }}
          spacingX={8}
          spacingY={0}
          templateColumns={{ md: 'minmax(12rem, max-content) 1fr' }}
          fontSize="sm"
        >
          {rows.map(({ el, en, value }) => (
            <Box key={el} display="contents">
              <Box as="dt" pt={{ base: 3, md: 2 }} fontWeight="semibold">
                {el}
                <Text as="span" fontWeight="normal" color={mutedText}>
                  {' '}
                  / {en}
                </Text>
              </Box>
              <Box as="dd" pb={{ base: 1, md: 2 }} pt={{ base: 0, md: 2 }}>
                {value}
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};
